(function () {
  const CSS_CLASS = 'has-combo-deal';

  function injectStyles() {
    if (document.getElementById('combodeal-pricing-styles')) return;

    const style = document.createElement('style');
    style.id = 'combodeal-pricing-styles';
    style.textContent = `
      /* Hide native Impulse price & savings when combo deal is active */
      .product-block--price.${CSS_CLASS} [data-product-price],
      .product-block--price.${CSS_CLASS} [data-save-price],
      .product-block--price.${CSS_CLASS} .price__no-promotion {
        display: none !important;
      }

      /* Injected combo elements display */
      [data-combo-price],
      [data-combo-save-price] {
        display: none;
      }
      .product-block--price.${CSS_CLASS} [data-combo-price],
      .product-block--price.${CSS_CLASS} [data-combo-save-price] {
        display: inline !important;
      }
    `;
    document.head.appendChild(style);
  }

  function fPrice(amount) {
    return (
      amount.toLocaleString('fi-FI', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' €'
    );
  }

  function getTargetSection(e) {
    if (e && e.target && typeof e.target.closest === 'function') {
      const sec = e.target.closest('.product-section, .modal');
      if (sec) return sec;
    }

    const activeModal = document.querySelector('.modal.modal--is-active, .modal.is-active, .modal[open]');
    if (activeModal) {
      return activeModal.querySelector('.product-section') || activeModal;
    }

    return document.querySelector('.product-section:not(.is-modal)') || document.querySelector('.product-section');
  }

  function ensureInjectedElements(priceBlock) {
    const priceEl = priceBlock.querySelector('[data-product-price]');
    const savePriceEl = priceBlock.querySelector('[data-save-price]');

    if (priceEl && !priceBlock.querySelector('[data-combo-price]')) {
      const comboPriceEl = document.createElement('span');
      comboPriceEl.setAttribute('data-combo-price', '');
      comboPriceEl.className = 'product__price on-sale';
      priceEl.parentNode.insertBefore(comboPriceEl, priceEl.nextSibling);
    }

    if (savePriceEl && !priceBlock.querySelector('[data-combo-save-price]')) {
      const comboSaveEl = document.createElement('span');
      comboSaveEl.setAttribute('data-combo-save-price', '');
      comboSaveEl.className = 'product__price-savings';
      savePriceEl.parentNode.insertBefore(comboSaveEl, savePriceEl.nextSibling);
    }

    let priceWOcombo = priceBlock.querySelector('.price-wo-pd');
    if (!priceWOcombo) {
      priceWOcombo = document.createElement('div');
      priceWOcombo.className = 'price-wo-pd';

      const priceWO = document.createElement('span');
      priceWO.className = 'price-wo';

      const comboDisc = document.createElement('p');
      comboDisc.className = 'comboDisclaimer';
      comboDisc.textContent = 'Hinta voimassa ostaessasi vähintään 2 pakettidiilituotetta';

      priceWOcombo.appendChild(priceWO);
      priceWOcombo.appendChild(comboDisc);

      const policiesEl = priceBlock.querySelector('.product__policies');
      policiesEl ? priceBlock.insertBefore(priceWOcombo, policiesEl) : priceBlock.appendChild(priceWOcombo);
    }
  }

  function updateComboPrice(section, variantObj = null) {
    if (!section) return;

    const priceBlock = section.querySelector('.product-block--price');
    if (!priceBlock) return;

    const percent = parseFloat(priceBlock.dataset.combodealPercent);
    if (isNaN(percent) || percent <= 0) {
      priceBlock.classList.remove(CSS_CLASS);
      return;
    }

    ensureInjectedElements(priceBlock);

    // Determine current variant base price (in EUR)
    let basePrice = null;
    if (variantObj && typeof variantObj.price === 'number') {
      basePrice = variantObj.price / 100;
    } else {
      const nativePriceEl = priceBlock.querySelector('[data-product-price]');
      if (nativePriceEl) {
        basePrice = parseFloat(nativePriceEl.textContent.replace(/[^\d,.-]/g, '').replace(',', '.'));
      }
    }

    if (isNaN(basePrice) || basePrice <= 0) return;

    const discountAmount = Math.round(basePrice * (percent / 100) * 100) / 100;
    const salePrice = Math.round((basePrice - discountAmount) * 100) / 100;

    const basePriceF = fPrice(basePrice);
    const salePriceF = fPrice(salePrice);
    const savingsF = 'Säästä ' + fPrice(discountAmount);

    const comboPriceEl = priceBlock.querySelector('[data-combo-price]');
    const comboSaveEl = priceBlock.querySelector('[data-combo-save-price]');
    const priceWOSpan = priceBlock.querySelector('.price-wo');

    if (comboPriceEl && comboPriceEl.textContent !== salePriceF) {
      comboPriceEl.textContent = salePriceF;
    }
    if (comboSaveEl && comboSaveEl.textContent !== savingsF) {
      comboSaveEl.textContent = savingsF;
    }
    if (priceWOSpan) {
      const newWOText = 'Hinta ilman pakettidiiliä ' + basePriceF;
      if (priceWOSpan.textContent !== newWOText) {
        priceWOSpan.textContent = newWOText;
      }
    }

    if (!priceBlock.classList.contains(CSS_CLASS)) {
      priceBlock.classList.add(CSS_CLASS);
    }
  }

  function init() {
    injectStyles();

    // 1. Initial verification for all mounted sections
    document.querySelectorAll('.product-section, .modal').forEach((sec) => {
      updateComboPrice(sec);
    });

    // 2. Impulse variant switch event
    document.addEventListener('variant:change', (e) => {
      const section = getTargetSection(e);
      const variant = e.detail ? e.detail.variant : null;
      if (section) {
        setTimeout(() => updateComboPrice(section, variant), 20);
      }
    });

    // 3. Fallback for option changes / swatch clicks
    document.addEventListener('change', (e) => {
      if (
        e.target &&
        typeof e.target.matches === 'function' &&
        e.target.matches('[data-variant-input], [name^="options["], select[data-product-select]')
      ) {
        const section = getTargetSection(e);
        if (section) {
          setTimeout(() => updateComboPrice(section), 40);
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();